import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';

function AccessSubsidized() {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [subsidized, setSubsidized] = useState(null);

  useEffect(() => {
    // Instantiate a new server to define where the RDS API is hosted.
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);
    function getCapacity() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'provider');

      const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} and is_subsidized=1 and license_type=LIC
      AND (setting_type=HOM OR setting_type=CEN)`;

      return rdsTabulate('ccdc', 'provider', {
        dims: 'state_fips',
        measure: 'count:COUNT(*)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    setReady(false);
    setError(null);
    Promise.all([getCapacity()])
      .then((responses) => {
        if (responses[0].parsedBody.dataProvider.length > 0) {
          setSubsidized(responses[0].parsedBody.dataProvider[0].count);
        } else {
          setError(new Error('No data returned'));
          setSubsidized(null);
        }
      })
      .catch((rdsError) => {
        // console.error(rdsError);
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return (
      <CircularProgress />
    );
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <Typography variant="body1" align="left">
        In <b>{states[stateCode.toUpperCase()]}</b>, <b>{toFormattedNumber(subsidized)}</b> licensed providers accept subsidies. Access to subsidized child care varies by setting type and quality rating.
      </Typography>
    </>
  );
}

export default AccessSubsidized;
